/*
https://splidejs.com/guides/getting-started/
*/
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const slider = document.querySelector('.doctor-credentials .splide');

if( slider ) {
    var splide = new Splide( slider, {
        type: 'loop',
        drag: false,
        autoWidth: true,
        easing: 'linear',
        arrows: false,
        pagination: false,
        perPage: 3,
        perMove: 1,
        speed: 0,
        autoScroll: {
            speed: 0.9,
            pauseOnHover: false,
            pauseOnFocus: false,
        },
        padding: {
            left: '10%',
            right: '10%'
        },
        gap: '30px',
        breakpoints: {
            960: {
                perPage: 2,
            },
            768: {
                perPage: 1,
                padding: {
                    left: '20%',
                    right: '20%'
                },
            },
        }
    });
    splide.mount({ AutoScroll });
}